import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="announcement-preview"
// Mirrors the announcement form fields into the preview rendered above it.
export default class extends Controller {
  static targets = ['variant', 'alert', 'icon', 'title', 'titleBox', 'body', 'colorField'];
  static values = { placeholders: Object };

  static COLORS = ['info', 'warning', 'danger', 'success'];
  static ICONS = { info: 'info-circle', warning: 'exclamation-triangle', danger: 'exclamation-circle', success: 'check-circle' };

  connect() {
    this.refresh = () => this.update();
    this.element.addEventListener('input', this.refresh);
    this.element.addEventListener('change', this.refresh);
    this.element.addEventListener('trix-change', this.refresh);
  }

  disconnect() {
    ['input', 'change', 'trix-change'].forEach((name) => this.element.removeEventListener(name, this.refresh));
  }

  update() {
    const title = this.field('announcement[title]');
    if (title) {
      this.titleTargets.forEach((el) => { el.textContent = this.interpolate(title.value); });
      // The title is optional: no empty heading.
      this.titleBoxTargets.forEach((el) => el.classList.toggle('d-none', title.value.trim() === ''));
    }

    const editor = this.element.querySelector('trix-editor');
    if (editor) this.bodyTargets.forEach((el) => { el.innerHTML = this.interpolate(editor.innerHTML, true); });

    const format = this.checked('announcement[display_format]');
    if (format) {
      this.variantTargets.forEach((el) => el.parentElement.classList.toggle('d-none', el.dataset.format !== format));
      // Modals have no color.
      if (this.hasColorFieldTarget) this.colorFieldTarget.classList.toggle('d-none', format === 'modal');
    }

    const color = this.checked('announcement[color]');
    if (color) this.applyColor(color);
  }

  applyColor(color) {
    const colors = this.constructor.COLORS;
    this.alertTargets.forEach((el) => {
      colors.forEach((c) => el.classList.remove(`alert-${c}`));
      el.classList.add(`alert-${color}`);
    });
    // Fresh <i> each time: FontAwesome turns it into an <svg> that does not follow class changes.
    this.iconTargets.forEach((el) => {
      const icon = document.createElement('i');
      icon.className = `fas fa-${this.constructor.ICONS[color]} depozen-ui-callout__icon`;
      icon.setAttribute('aria-hidden', 'true');
      el.replaceChildren(icon);
    });
  }

  field(name) {
    return this.element.querySelector(`[name="${name}"]`);
  }

  checked(name) {
    return this.element.querySelector(`[name="${name}"]:checked`)?.value;
  }

  interpolate(text, escape = false) {
    return text.replace(/%\{(\w+)\}/g, (match, key) => {
      const value = this.placeholdersValue[key];
      if (value === undefined) return match;
      if (!escape) return value;

      const span = document.createElement('span');
      span.textContent = value;
      return span.innerHTML;
    });
  }
}
